import { ThunkDispatch as Dispatch } from "redux-thunk";

import logger from "../utils/logger";
import { WalletAdapterName } from "../adapters/WalletAdapter";
import { State } from "../types";
import { Actions } from "./types";
import { createNotificationAction } from "./notification";
import { ACTION_TYPES } from "./constants";

type CreateNotificationAction = ReturnType<typeof createNotificationAction>;

export const connectWalletAction =
  (name: WalletAdapterName) =>
  async (
    dispatch: Dispatch<
      State,
      void,
      Actions.ConnectWallet | CreateNotificationAction
    >
  ) => {
    const { adapter, label } =
      window.__UXD__.solana.config.getWalletAdapter(name);

    adapter.on("connect", () => {
      dispatch({
        type: ACTION_TYPES.CONNECT_WALLET,
        payload: name,
      });

      dispatch(
        createNotificationAction({
          title: "Wallet Connected",
          message: `You are now connected with ${label}.`,
          level: "success",
          icon: "link",
        })
      );
    });

    try {
      await adapter.connect();
    } catch (err) {
      logger.error(new Error(`unable to connect to wallet ${name}`), { err });
    }
  };

export const disconnectWalletAction =
  (name: WalletAdapterName) =>
  async (
    dispatch: Dispatch<
      State,
      void,
      Actions.DisconnectWallet | CreateNotificationAction
    >
  ) => {
    const { adapter } = window.__UXD__.solana.config.getWalletAdapter(name);

    adapter.on("disconnect", () => {
      dispatch({ type: ACTION_TYPES.DISCONNECT_WALLET });

      dispatch(
        createNotificationAction({
          title: "Wallet Disconnected",
          message: `Your wallet is now disconnected.`,
          level: "warning",
          icon: "linkBroken",
        })
      );
    });

    try {
      await adapter.disconnect();
    } catch (err) {
      logger.error(new Error(`unable to disconnect to wallet ${name}`), {
        err,
      });
    }
  };
